import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetActiveClientMutationVariables = Types.Exact<{
  input: Types.SetActiveClientInput;
}>;


export type SetActiveClientMutation = { __typename?: 'Mutation', setActiveClient: { __typename?: 'ActiveClientMutationResult', success: boolean } };

export type RemoveActiveClientMutationVariables = Types.Exact<{
  clientId: Types.Scalars['String']['input'];
}>;


export type RemoveActiveClientMutation = { __typename?: 'Mutation', removeActiveClient: { __typename?: 'BaseMutationResult', success: boolean } };


export const SetActiveClientDocument = gql`
    mutation SetActiveClient($input: SetActiveClientInput!) {
  setActiveClient(input: $input) {
    success
  }
}
    `;
export type SetActiveClientMutationFn = Apollo.MutationFunction<SetActiveClientMutation, SetActiveClientMutationVariables>;

/**
 * __useSetActiveClientMutation__
 *
 * To run a mutation, you first call `useSetActiveClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveClientMutation, { data, loading, error }] = useSetActiveClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetActiveClientMutation(baseOptions?: Apollo.MutationHookOptions<SetActiveClientMutation, SetActiveClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActiveClientMutation, SetActiveClientMutationVariables>(SetActiveClientDocument, options);
      }
export type SetActiveClientMutationHookResult = ReturnType<typeof useSetActiveClientMutation>;
export type SetActiveClientMutationResult = Apollo.MutationResult<SetActiveClientMutation>;
export type SetActiveClientMutationOptions = Apollo.BaseMutationOptions<SetActiveClientMutation, SetActiveClientMutationVariables>;
export const RemoveActiveClientDocument = gql`
    mutation RemoveActiveClient($clientId: String!) {
  removeActiveClient(clientId: $clientId) {
    success
  }
}
    `;
export type RemoveActiveClientMutationFn = Apollo.MutationFunction<RemoveActiveClientMutation, RemoveActiveClientMutationVariables>;

/**
 * __useRemoveActiveClientMutation__
 *
 * To run a mutation, you first call `useRemoveActiveClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveActiveClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeActiveClientMutation, { data, loading, error }] = useRemoveActiveClientMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useRemoveActiveClientMutation(baseOptions?: Apollo.MutationHookOptions<RemoveActiveClientMutation, RemoveActiveClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveActiveClientMutation, RemoveActiveClientMutationVariables>(RemoveActiveClientDocument, options);
      }
export type RemoveActiveClientMutationHookResult = ReturnType<typeof useRemoveActiveClientMutation>;
export type RemoveActiveClientMutationResult = Apollo.MutationResult<RemoveActiveClientMutation>;
export type RemoveActiveClientMutationOptions = Apollo.BaseMutationOptions<RemoveActiveClientMutation, RemoveActiveClientMutationVariables>;